class Theme {
    constructor({ fontFamilies, fontSizes, fontWeights, lineHeights, breakpoints, components, typography, cssVariables, text, icon, background }) {
        this.fontFamilies = fontFamilies;
        this.fontSizes = fontSizes;
        this.fontWeights = fontWeights;
        this.lineHeights = lineHeights;
        this.breakpoints = breakpoints;
        this.components = components;
        this.typography = typography;
        this.cssVariables = cssVariables;
        this.text = text;
        this.icon = icon;
        this.background = background;
    }
}

export default Theme;
